import { KeyboardEventHandler } from "react";

import PersonSearchRounded from "@mui/icons-material/PersonSearchRounded";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown: KeyboardEventHandler<HTMLInputElement>;
  onSearch: () => void;

  ariaExpanded: boolean;
  ariaControls: string;
  ariaActivedescendant?: string;
}

export function ClientSearchInput({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onSearch,
  ariaExpanded,
  ariaControls,
  ariaActivedescendant,
}: Props) {
  const { t } = useTranslation();

  return (
    <TextField
      variant="outlined"
      size="small"
      color="primary"
      placeholder={t("layout.header.clientSmartSearch.placeholder")}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      role="combobox"
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-activedescendant={ariaActivedescendant}
      aria-label={t("layout.header.clientSmartSearch.placeholder")}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end" aria-label={t("layout.header.clientSmartSearch.search")} onClick={onSearch}>
                <PersonSearchRounded />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiIconButton-root": {
          color: "primary.main",
        },
        "& .MuiIconButton-root": {
          color: "action.active",
          transition: "color 0.2s",
        },
      }}
    />
  );
}
